module.exports = __webpack_public_path__ + "website/img/successfulDetail_4_5.fa5b1fb4.png";